import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RequestAccessController } from "entities/Request/utils/RequestAccessController";
import { Card, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Icons from "shared/icons";

const access = new RequestAccessController();

function ReasonOfRejection({ comment }) {
  const { t } = useTranslation("Request");
  if (access.to("ReasonOfRejection", "view").provided() && comment?.length)
    return (
      <Card className="text-danger mb-5 p-3" body>
        <Stack direction="horizontal" gap={4} className="mb-2">
          <FontAwesomeIcon icon={Icons.triangleExclamation} />
          <Card.Title className="mb-0">
            {t("reason_of_rejection_title")}
          </Card.Title>
        </Stack>
        <Card.Text className="text-start">
          <strong>{t("reason_of_rejection_label")}</strong>
          {comment}
        </Card.Text>
      </Card>
    );
}

export default ReasonOfRejection;
